import { EnvironmentProviders } from '@angular/core';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideAnalytics, getAnalytics } from '@angular/fire/analytics';
import { providePerformance, getPerformance } from '@angular/fire/performance';
import { provideMessaging, getMessaging } from '@angular/fire/messaging';
import { environment } from '@env/environment';

export const provideFirebase = (): EnvironmentProviders[] => {
  if (!environment.production || !environment.firebase) {
    return [];
  }

  return [
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAnalytics(() => getAnalytics()),
    providePerformance(() => getPerformance()),
    provideMessaging(() => getMessaging()),
  ];
};
